export enum FlowSendAreaEnum {

  Local = 1,
  External = 2

}
